<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('branch.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          { text: $t('branch.pageTitle'), href: '/branches' },
          { text: $t('create'), active: true }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-sm-12 col-lg-3 col-md-5">
          <ts-card>
            <ts-card-wrapper>
              <div class="ts-space-y-3">
                <div class="row">
                  <div class="col-md-12">
                    <div id="img-frame" class="text-center">
                      <label for="logo_file" id="label_logo_file">
                        <img :src="logo_file_src" alt />
                      </label>
                      <input
                        type="file"
                        id="logo_file"
                        ref="logo_file"
                        accept="image/*"
                        @change="onFileSelected"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>
                      {{ $t('branch.companyName') }}
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      v-model="model.company_id"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('company_id') }"
                    >
                      <option value>--Select--</option>
                      <option
                        v-for="(company, index) in companies"
                        :key="index"
                        :value="company.company_id"
                        >{{ company.company_name_en }}</option
                      >
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('company_id')"
                    >
                      {{ errors.first('company_id') }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>
                      {{ $t('branch.code') }}
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="model.branch_code"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('branch_code') }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('branch_code')"
                    >
                      {{ errors.first('branch_code') }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>
                      {{ $t('branch.publicIp') }}
                    </label>
                    <input
                      type="text"
                      v-model="model.att_public_ip"
                      placeholder="000.000.000.000"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('att_public_ip') }"
                    />
                    <small><i>Example: 172.31.255.255</i></small>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('att_public_ip')"
                    >
                      {{ errors.first('att_public_ip') }}
                    </div>
                  </div>
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </div>
        <div class="col-sm-12 col-lg-9 col-md-7">
          <ts-card>
            <ts-card-wrapper>
              <div class="row">
                <div class="col-md-6 col-sm-12 ts-space-y-1">
                  <div class="row">
                    <div class="col-md-12">
                      <label class="col-form-label control-label">
                        {{ $t('branch.nameKh') }}
                      </label>
                      <input
                        type="text"
                        v-model="model.branch_name_kh"
                        class="form-control kh-font"
                        :class="{ 'is-invalid': errors.has('branch_name_kh') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('branch_name_kh')"
                      >
                        {{ errors.first('branch_name_kh') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="required col-form-label control-label">
                        {{ $t('branch.nameEn') }}
                      </label>
                      <input
                        type="text"
                        v-model="model.branch_name_en"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('branch_name_en') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('branch_name_en')"
                      >
                        {{ errors.first('branch_name_en') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="col-form-label control-label">{{
                        $t('branch.phone')
                      }}</label>
                      <input
                        type="text"
                        v-model="model.branch_phone"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('branch_phone') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('branch_phone')"
                      >
                        {{ errors.first('branch_phone') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="col-form-label control-label">
                        {{ $t('branch.email') }}
                      </label>
                      <input
                        type="email"
                        v-model="model.branch_email"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('branch_email') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('branch_email')"
                      >
                        {{ errors.first('branch_email') }}
                      </div>
                    </div>
                  </div>
                  <!-- branch address -->
                  <branch-address v-model="model"></branch-address>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="row">
                    <div class="col-md-12">
                      <label class="col-form-label control-label">
                        {{ $t('branch.address') }}
                      </label>
                      <textarea
                        v-model="model.branch_address"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('branch_address') }"
                        rows="3"
                      ></textarea>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('branch_address')"
                      >
                        {{ errors.first('branch_address') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="col-form-label control-label">
                        {{ $t('branch.distanceAllow') }}
                      </label>
                      <input 
                        type="number"
                        v-model.number="model.distance_allow_in_metter"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('distance_allow_in_metter')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('distance_allow_in_metter')"
                      >
                        {{ errors.first('distance_allow_in_metter') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 ts-space-y-1">
                      <label class="col-form-label control-label">{{
                        $t('branch.geoLocation')
                      }}</label>
                      <div class="row">
                        <div class="col-md-6">
                          <input 
                            type="text" 
                            class="form-control" 
                            readonly
                            :value="coordinate"
                          >
                        </div>
                        <div class="col-md-6">
                          <TsMapAutocomplete
                            @setLocation="setPlaceOrLocation"
                          />
                        </div>
                      </div>
                      <div
                        class="ts-text-red-600 ts-text-xs"
                        v-if="errors.has('destination')"
                      >
                        {{ errors.first('destination') }}
                      </div>
                      <GmapMap
                        :center="center"
                        :zoom="zoom"
                        :options="{
                          streetViewControl: true
                        }"
                        map-type-id="roadmap"
                        class="ts-w-full ts-h-64 ts-mt-2"
                        @click="mapClick"
                      >
                        <GmapMarker
                          :clickable="true"
                          :draggable="true"
                          :position="marker"
                        />
                      </GmapMap>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-12 col-lg-12 col-md-12 ts-flex ts-justify-end ts-mt-5 ts-space-x-3"
                >
                  <ts-button
                    @click.prevent="$router.push({ name: 'branch' })"
                    >{{ $t('cancel') }}</ts-button
                  >
                  <ts-button
                    color="primary"
                    outline
                    :waiting="waiting_save_add_new"
                    @click.prevent="saveAddNew"
                    >{{ $t('save_add_new') }}</ts-button
                  >
                  <ts-button
                    color="primary"
                    :waiting="waiting"
                    @click.prevent="save"
                    >{{ $t('save') }}</ts-button
                  >
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import BranchAddress from './address.vue'

export default {
  name: 'branchCreate',
  components: {
    BranchAddress
  },
  data () {
    return {
      model: {
        branch_id: 0,
        company_id: '',
        branch_code: '',
        branch_name_kh: '',
        branch_name_en: '',
        branch_phone: '',
        branch_email: '',
        branch_address: '',
        branch_logo: null,
        att_public_ip: '',
        distance_allow_in_metter: null,
        geo_location: {
          lat: '',
          lng: ''
        },
        province_code: null,
        disctrict_code: null,
        commune_code: null,
        village_code: null,
        house_no: null,
        street_no: null
      },
      zoom: 7,
      center: { lat: 12.565679, lng: 104.990967 },
      marker: { lat: 0, lng: 0 },
      errors: new Errors(),
      companies: [],
      waiting: false,
      loading: false,
      waiting_save_add_new: false,
      file: '',
      logo_file_src: require('../../../assets/upload.png')
    }
  },
  computed: {
    coordinate() {
      return this.model.geo_location.lat + ' ' + this.model.geo_location.lng
    }
  },
  created () {
    this.onFetch()
  },
  methods: {
    onFetch () {
      this.loading = true
      this.$store
        .dispatch('corporate/branch/company')
        .then(response => {
          this.companies = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    onFileSelected () {
      const file = this.$refs.logo_file.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.logo_file_src = require('../../../assets/upload.png')

          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },

    async uploadfile (id) {
      this.file = this.$refs.logo_file.files[0]
        ? this.$refs.logo_file.files[0]
        : null
      if ((this.file instanceof File) | Blob) {
        let formData = new FormData()
        formData.append('branch_logo', this.file)
        formData.append('id', id)
        return await this.$store.dispatch('corporate/branch/upload', formData)
      }

      return ''
    },
    async save () {
      this.errors = new Errors()
      this.waiting = true
      await this.$store
        .dispatch('corporate/branch/store', this.model)
        .then(async response => {
          await this.uploadfile(response.id)
          this.clearFormInput()
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'branch' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async saveAddNew () {
      this.errors = new Errors()
      this.waiting_save_add_new = true
      this.$store
        .dispatch('corporate/branch/store', this.model)
        .then(async response => {
          await this.uploadfile(response.id)
          this.clearFormInput()
          this.waiting_save_add_new = false
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.waiting_save_add_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    clearFormInput () {
        this.model.company_id = ''
        this.model.branch_code = ''
        this.model.branch_name_kh = ''
        this.model.branch_name_en = ''
        this.model.branch_phone = ''
        this.model.branch_email = ''
        this.model.branch_address = ''
        this.model.distance_allow_in_metter = ''
        this.model.att_public_ip = ''
        this.model.geo_location = {
          lat: '',
          lng: ''
        }
        this.model.province_code = ''
        this.model.disctrict_code = ''
        this.model.commune_code = ''
        this.model.village_code = ''
        this.model.house_no = ''
        this.model.street_no = ''
        this.$refs.logo_file.value = ''
        this.logo_file_src = require('../../../assets/upload.png')
    },
    mapClick (value) {
      this.marker.lat = value.latLng.lat()
      this.marker.lng = value.latLng.lng()
      this.model.geo_location.lat = value.latLng.lat()
      this.model.geo_location.lng = value.latLng.lng()
    },
    setPlaceOrLocation (location) {
      this.center = {
        lat: location.lat,
        lng: location.lng
      }
      this.marker = this.center
      ;(this.model.geo_location.lat = location.lat),
        (this.model.geo_location.lng = location.lng)
      this.zoom = 18
    },
    formatIp(e){
      var value = e.target.value
      console.log(value);
    }
  }
}
</script>
<style scoped>
#logo_file {
  display: none;
}
#img-frame img {
  object-fit: contain;
  width: 165px;
  height: 142px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, .1); */
  border-radius: 10px;
  padding: 5px;
}
#label_logo_file {
  cursor: pointer;
}
</style>
